import { configureStore } from '@reduxjs/toolkit';
import { IPublicClientApplication } from '@azure/msal-browser';
import rootReducer from './rootReducer';
import { createSseMiddleware } from './middleware/sseMiddleware';

// Factory instead of a singleton so the shared msalInstance can be injected.
export function configureAppStore(msalInstance: IPublicClientApplication) {
    return configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(createSseMiddleware(msalInstance)),
    });
}

export type AppStore = ReturnType<typeof configureAppStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export default configureAppStore;
